import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

const resolvePageTitle = (pathname) => {
  if (pathname === "/") return "A1 Pro | Cursos y Paquetes Premium";
  if (pathname === "/product") return "Cursos | A1 Pro";
  if (pathname.startsWith("/product/")) return "Detalle de Curso | A1 Pro";
  if (pathname === "/about") return "Sobre Nosotros | A1 Pro";
  if (pathname === "/contact") return "Contacto | A1 Pro";
  if (pathname === "/cart") return "Carrito | A1 Pro";
  if (pathname === "/checkout") return "Finalizar Compra | A1 Pro";
  if (pathname === "/como-comprar") return "Como Comprar | A1 Pro";
  if (pathname === "/privacy") return "Politica de Privacidad | A1 Pro";
  return "A1 Pro | Cursos y Paquetes Premium";
};

const ScrollToTop = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 650,
      easing: "ease-out",
      once: true,
      offset: 80,
    });
  }, []);

  useEffect(() => {
    document.title = resolvePageTitle(pathname);
  }, [pathname]);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
    AOS.refresh();
  }, [pathname, hash]);

  return children || null;
};

export default ScrollToTop;
